import React, { useRef, useState, useEffect, useCallback } from "react";
import NotificationAlert from "react-notification-alert";
import { Modal, ModalBody, ModalFooter, Button } from "reactstrap";
import feedback from "../../services/feedback";

export const FeedbackProvider = ({ children }) => {
    const notifyRef = useRef(null);

    const [confirmState, setConfirmState] = useState({
        isOpen: false,
        title: "",
        message: "",
        confirmText: "Confirm",
        cancelText: "Cancel",
        danger: false,
        resolve: null
    });

    const notify = useCallback(({ type = "primary", title = "", message }) => {
        if (!notifyRef.current) return;

        const options = {
            place: "tc",
            message: (
                <div className="alert-text">
                    {title && (
                        <span className="alert-title" data-notify="title">
                            {" "}
                            {title}
                        </span>
                    )}
                    <span data-notify="message">
                        {message}
                    </span>
                </div>
            ),
            type: type,
            icon: "ni ni-bell-55",
            autoDismiss: 7,
        };

        notifyRef.current.notificationAlert(options);
    }, []);

    const confirm = useCallback(({ title = "Confirmation", message, confirmText = "Confirm", cancelText = "Cancel", danger = false }) => {
        return new Promise((resolve) => {
            setConfirmState({
                isOpen: true,
                title,
                message,
                confirmText,
                cancelText,
                danger,
                resolve
            });
        });
    }, []);

    useEffect(() => {
        feedback.notify = notify;
        feedback.confirm = confirm;
    }, [notify, confirm]);

    const handleConfirm = () => {
        if (confirmState.resolve) confirmState.resolve(true);
        setConfirmState(prev => ({ ...prev, isOpen: false }));
    };

    const handleCancel = () => {
        if (confirmState.resolve) confirmState.resolve(false);
        setConfirmState(prev => ({ ...prev, isOpen: false }));
    };

    return (
        <>
            <div className="rna-wrapper">
                <NotificationAlert ref={notifyRef} />
            </div>

            <Modal isOpen={confirmState.isOpen} toggle={handleCancel} className="modal-dialog-centered">
                <div className="modal-header">
                    <h5 className="modal-title">{confirmState.title}</h5>
                    <button
                        type="button"
                        className="close"
                        data-dismiss="modal"
                        aria-label="Close"
                        onClick={handleCancel}
                    >
                        <span aria-hidden="true">×</span>
                    </button>
                </div>
                <ModalBody>
                    {confirmState.message}
                </ModalBody>
                <ModalFooter>
                    <Button color="secondary" outline onClick={handleCancel}>
                        {confirmState.cancelText}
                    </Button>
                    <Button color={confirmState.danger ? "danger" : "primary"} onClick={handleConfirm}>
                        {confirmState.confirmText}
                    </Button>
                </ModalFooter>
            </Modal>

            {children}
        </>
    );
};

export default FeedbackProvider;
